import axiosInstance from '../../api/axios';

// Mirrors skeptics-backend's `/api/dashboards/:key/layout` contract
// (`{ layout, is_default }`). The backend stores `layout` as an opaque JSON
// array and only requires a non-empty `widget_key` per entry. Each user has
// one dashboard, saved under the `main` key; array order is display order.
export type DashboardKey = 'main';

export type DashboardWidgetRef = {
  widget_key: string;
};

export type DashboardLayoutResponse = {
  layout: DashboardWidgetRef[];
  is_default: boolean;
};

const BASE = '/api/dashboards';

export const fetchDashboardLayout = async (key: DashboardKey): Promise<DashboardLayoutResponse> => {
  const response = await axiosInstance.get<DashboardLayoutResponse>(`${BASE}/${encodeURIComponent(key)}/layout`);
  return {
    layout: response?.data?.layout ?? [],
    is_default: response?.data?.is_default ?? true,
  };
};

export const saveDashboardLayout = async (
  key: DashboardKey,
  layout: DashboardWidgetRef[]
): Promise<DashboardLayoutResponse> => {
  const response = await axiosInstance.put<DashboardLayoutResponse>(`${BASE}/${encodeURIComponent(key)}/layout`, {
    layout,
  });
  return {
    layout: response?.data?.layout ?? layout,
    is_default: response?.data?.is_default ?? false,
  };
};

export const resetDashboardLayout = async (key: DashboardKey): Promise<DashboardLayoutResponse> => {
  const response = await axiosInstance.delete<DashboardLayoutResponse>(`${BASE}/${encodeURIComponent(key)}/layout`);
  return {
    layout: response?.data?.layout ?? [],
    is_default: response?.data?.is_default ?? true,
  };
};
